import { createApp } from 'vue'
import { createHead } from '@unhead/vue/client'
import App from './App.vue'
import router from './router'
import './assets/styles/global.css'
import 'font-awesome/css/font-awesome.min.css'
import './assets/styles/tailwind.css'

const app = createApp(App)
const head = createHead()
app.use(head)
app.use(router)
app.mount('#app')
